export default {
  choose: {
    title: '{{name}} niet langer als eigenaar instellen',
    title_no_owner: 'Kies een eigenaar voor {{restaurant}}',
    description: 'Kies wie het overneemt van {{name}}, of laat {{restaurant}} voorlopig zonder eigenaar.',
    description_no_owner: '{{restaurant}} heeft geen eigenaar. Kies iemand uit het team of iemand nieuws.',
    new_owner: 'Nieuwe eigenaar',
    previous_owner: '{{name}} na de wijziging',
  },
  options: {
    team: {
      title: 'Iemand uit het team',
      loading: 'De team wordt geladen…',
      description_one: 'Elke operator of medewerker, {{count}} persoon.',
      description_other: 'Elke operator of medewerker, {{count}} personen.',
      empty: 'Er is nog niemand anders in het team.',
      search: 'Zoek in het team op naam of e-mail',
      no_match: 'Niemand in het team komt overeen met “{{query}}”.',
    },
    new: {
      title: 'Iemand nieuws',
      description: 'Die persoon is meteen eigenaar en krijgt de inloggegevens per e-mail.',
    },
    none: {
      title: 'Voorlopig geen eigenaar',
      description: 'Kies later een eigenaar. Tot dan heeft {{restaurant}} geen eigenaar.',
    },
    keep: {
      title: 'Blijft in het team als operator',
      description: 'Behoudt toegang tot de restaurants die hij of zij nu beheert.',
    },
    remove: {
      title: 'Verwijderd uit het team',
      description: 'Verliest meteen toegang tot het dashboard.',
    },
  },
  roles: {
    operator: 'Operator',
    employee: 'Medewerker',
  },
  fields: {
    first_name: 'Voornaam',
    last_name: 'Achternaam',
    email: 'E-mail',
  },
  email_errors: {
    invalid_email: 'Voer een geldig e-mailadres in, zoals naam@voorbeeld.nl.',
    email_is_owner: '{{name}} is al de eigenaar.',
    email_is_manager: '{{name}} zit al in het team.',
    email_taken: 'Iemand buiten dit team logt al in met dit e-mailadres. Gebruik een ander e-mailadres.',
  },
  confirm: {
    title: '{{name}} niet langer als eigenaar instellen?',
    title_no_owner: '{{name}} eigenaar maken?',
    description_both: 'Beide wijzigingen gebeuren tegelijk. Mislukt er één, dan verandert er niets.',
    description: 'Controleer de wijziging voordat je bevestigt.',
  },
  summary: {
    none: '<b>{{restaurant}}</b> heeft geen eigenaar tot je er een kiest. Alles wat de eigenaar nodig heeft, wacht tot die tijd.',
    new: '<b>{{name}}</b> wordt meteen eigenaar van {{restaurant}}.',
    email:
      'De inloggegevens gaan naar <b>{{email}}</b>. Controleer dit goed: wie dit e-mailadres heeft, kan als eigenaar inloggen.',
    team: '<b>{{name}}</b> wordt eigenaar van {{restaurant}}.',
    group_access: 'Als eigenaar krijgt die persoon toegang tot alle restaurants van {{group}}, mogelijk meer dan nu.',
    keep: '<b>{{name}}</b> blijft in het team als operator.',
    remove: '<b>{{name}}</b> wordt uit het team verwijderd en kan niet meer inloggen.',
  },
  error: {
    title: 'Kon de eigenaar niet wijzigen.',
    description: 'Er is niets gewijzigd. Probeer het opnieuw of neem contact op met support als het blijft mislukken.',
  },
  buttons: {
    continue: 'Doorgaan',
    cancel: 'Annuleren',
    back: 'Terug',
    remove_as_owner: 'Niet langer eigenaar maken',
    make_owner: 'Eigenaar maken',
    saving: 'Opslaan…',
    try_again: 'Opnieuw proberen',
    choose_instead: 'Kies liever {{name}}',
    invite_instead: 'Nodig liever iemand nieuws uit',
  },
};
